module.exports = __webpack_public_path__ + "static/img/6.7de123a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/2/1/eng/6.png
// module id = W542
// module chunks = 0